import { request } from '@services'

export const state = {
  loading: false,
  data: null,
  errors: null,
}

export const getters = {
  getChartDataNotificationAgentAdmin(state) {
    return state.data
  },
}

export const mutations = {
  SET_CHART_DATA_NOTIFICATION_AGENT_ADMIN_REQUESTED(state) {
    state.loading = true
  },
  SET_CHART_DATA_NOTIFICATION_AGENT_ADMIN_RECEIVED(state, newData) {
    state.loading = false
    state.data = newData
    state.errors = null
  },
  SET_CHART_DATA_NOTIFICATION_AGENT_ADMIN_RECEIVED_FAILED(state, error) {
    state.loading = false
    state.errors = error
  },
  RESET_CHART_DATA_NOTIFICATION_AGENT_ADMIN(state) {
    state.loading = false
    state.data = null
    state.errors = null
  },
}

export const actions = {
  async fetchingChartDataNotificationAgentAdmin({ commit }, params) {
    commit('SET_CHART_DATA_NOTIFICATION_AGENT_ADMIN_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/notification/overview/',
        payload: { ...params },
      })
      commit('SET_CHART_DATA_NOTIFICATION_AGENT_ADMIN_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_CHART_DATA_NOTIFICATION_AGENT_ADMIN_RECEIVED_FAILED', error)
    }
  },
}
